import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Imported before App so the brand CSS variables are on <html> before first paint
// (importing the module is what applies them — the named import still runs it).
import { BRAND_NAME, FAVICON_SRC, APPLE_TOUCH_ICON_SRC } from './theme/brand';
// Retints react-select's default theme; must run before any dropdown renders.
import './theme/reactSelectTheme';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


// index.html ships the defaults so an env-less build is already correct; these
// rewrite them from the REACT_APP_BRAND_* vars for a rebranded deployment.
document.title = `${BRAND_NAME} Customer Portal`;
document
  .querySelector('meta[name="description"]')
  ?.setAttribute('content', `${BRAND_NAME} Customer Portal`);

// Icons: REPLACE the <link> rather than just setting .href. Browsers cache the
// favicon per document and several ignore an in-place href change on a link they
// have already fetched; removing the node and appending a fresh one makes them
// re-resolve it. Skipped entirely when the resolved path already matches, so the
// default build never touches an icon it has just loaded.
function applyIcon(rel, href) {
  const existing = document.querySelector(`link[rel="${rel}"]`);
  if (existing && existing.getAttribute('href') === href) return;
  if (existing) existing.remove();
  const link = document.createElement('link');
  link.rel = rel;
  link.href = href;
  document.head.appendChild(link);
}
applyIcon('icon', FAVICON_SRC);
applyIcon('apple-touch-icon', APPLE_TOUCH_ICON_SRC);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 
  <BrowserRouter>
   <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    <App />
  </BrowserRouter>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
